export default class splashMot {
    constructor(effect,util,param) {

        this.effect = effect
        this.util = util
        this.param = param

        this.$copy
        this.$show
        this.$fade
        this.$transX
        this.$transY
        this.$scale
        this.$mask
        this.$fixCircle

        this.obj = {
            maskX: 0,
            maskY: 0,
            sizse: 0,
        }
        
        this.status = {
            done : false
        }

        this.count = 0;

        this.loaded = false;

    }
    init(scroll, mouse) {

        this.$copy = document.querySelectorAll(".kv-title-inner-object")
        this.$fade = document.querySelectorAll(".js__splash-fade")
        this.$show = document.querySelectorAll(".js__splash-show")
        this.$transX = document.querySelectorAll(".js__splash-x")
        this.$transY = document.querySelectorAll(".js__splash-y")
        this.$scale = document.querySelectorAll(".js__splash-scale")
        this.$mask = document.querySelector('.l-bg_color');
        this.$fixCircle = document.getElementById("fix-circle")

        this.effect.split(this.$copy,"set")
        this.effect.show(this.$show,"set")
        this.effect.fade(this.$fade,"set")
        this.effect.panel(this.$transX,"set")
        this.effect.panel(this.$transY,"set",'y')
        this.effect.scale(this.$scale,"set")

    }
    show(scroll){

        //pc
        const _$copy1 = document.querySelectorAll(".kv-title-inner-object")[0]
        const _$copy2 = document.querySelectorAll(".kv-title-inner-object")[1]
        //sp
        const _$copy3 = document.querySelectorAll(".kv-title-inner-object")[2]

        let _delay = '2e3';

        if(this.param.displayType == 'sp'){
            _delay = 5e2;
        }

        setTimeout(()=>{

            this.loaded = true;

            const fadeIn = () => {

                if(this.param.displayType == 'sp') {
                    this.effect.split(_$copy3.children[0].children,"show")
                    this.effect.split(_$copy3.children[2].children,"show")
                    this.effect.split(_$copy3.children[3].children,"show")
                    this.effect.split(_$copy3.children[5].children[0].children,"show")
                }else{
                    this.effect.split(_$copy1.children[0].children, "show")
                    this.effect.split(_$copy1.children[1].children, "show")
                    this.effect.split(_$copy2.children[0].children, "show")
                    this.effect.split(_$copy2.children[1].children[0].children, "show")
                }

                this.effect.show(this.$show,"show")
                this.effect.panel(this.$transX,"show")
                this.effect.panel(this.$transY,"show")
                setTimeout(()=>{
                    this.effect.scale(this.$scale,"show")
                    setTimeout(()=>{
                        this.effect.fade(this.$fade,"show")
                    },1e3);
                },11e2);
                setTimeout(()=>{
                    scroll.exResize(scroll.bodyHeight,true)

                    this.status.done = true;
                    document.querySelector(".kv").classList.add("is-done")

                    if (location.hash) {
                        setTimeout(() => {
                            scroll.selectTo(location.hash.replace('#', ''))
                        }, 5e2)
                    }

                },1e3);
            }

            if(this.param.displayType == 'sp'){
                fadeIn();
            }else{
                let _x = (window.innerWidth/2);
                let _y = (window.innerHeight/2);
                let _xHalf = (window.innerWidth/2) - 225;
                let _yHalf = (window.innerHeight/2) - 225;

                TweenMax.set(this.$fixCircle,{
                    x: _x,
                    y: _y,
                })
                TweenMax.fromTo(this.$fixCircle,1.2,{
                    opacity: 0,
                    scale: 0,
                },{
                    delay: 1,
                    scale: 1,
                    opacity: 1
                })

                TweenMax.to(this.$mask, 1.8, {
                    css: {
                        '-webkit-mask-size': '450px 450px',
                        'mask-size': '450px 450px',
                        '-webkit-mask-position-x': _xHalf,
                        '-webkit-mask-position-y': _yHalf,
                        'mask-position-x': _xHalf,
                        'mask-position-y': _yHalf
                    },
                    onComplete: () => {
                        fadeIn();
                    }
                })
            }

        },_delay);

    }

    render(){

        if(this.loaded) return;

        this.count += 3;

        this.obj.maskX = (window.innerWidth/2) - (this.count * 4);
        this.obj.maskY = (window.innerHeight/2) - (this.count * 4);
        this.obj.size = this.count * 8 + 'px';

        TweenMax.set(this.$mask, {
            css: {
                '-webkit-mask-size': ''+this.obj.size+' '+this.obj.size+'',
                'mask-size': ''+this.obj.size+' '+this.obj.size+'',
                '-webkit-mask-position-x': this.obj.maskX,
                '-webkit-mask-position-y': this.obj.maskY,
                'mask-position-x': this.obj.maskX,
                'mask-position-y': this.obj.maskY
            }
        })

    }

}